cv.getStatus = function(model){

  var sections = {
    general : false,
    display_options : false,
    donation_form : false,
    peer_to_peer : false,
    custom_fields : false
  };

  var fields = {
    contact_email : false,
    contact_address : false,
    fb_og_image : false,
    fb_og_title : false,
    fb_og_description : false,

    funds_needed : false,
    metric_value : false,
    metric_description : false,

    payment_processor : false,
    tiers : false,
    recurring_processor : false,
    tip_percent : false,
    donation_receipt : false
  };

  if(model.get('contact_email') == ''){
    sections.general = true;
    fields.contact_email = true;
  }
  if(model.get('contact_address') == ''){
    sections.general = true;
    fields.contact_address = true;
  }
  if(model.get('fb_og_image') == ''){
    sections.display_optons = true;
    fields.fb_og_image  = true;
  }
  if(model.get('fb_og_title') == ''){
    sections.display_optons = true;
    fields.fb_og_title = true;
  }
  if(model.get('fb_og_description') == ''){
    sections.display_options = true;
    fields.fb_og_description = true;
  }

  // ---------------------------------------------------

  if(model.get('enable_funds_needed') == 1){
    if(model.get('funds_needed') == 0){
      sections.display_options = true;
      fields.funds_needed = true;
    }
  }

  if(model.get('enable_metric') == 1){
    if(model.get('metric_value') == 0){
      sections.display_options = true;
      fields.metric_value = true;
    }
    if(model.get('metric_description') == 0){
      sections.display_options = true;
      fields.metric_description = true;
    }
  }

  // ---------------------------------------------------

  if(model.get('tiers').length == 0){
    sections.donation_form = true;
    fields.tiers = true;
  }

  if(_.isUndefined(model.get('payment_processor.account_id'))){
    sections.donation_form = true;
    fields.payment_processor = true;
  }

  if(model.get('enable_recurring') == 1){
    if(model.get('recurring_processor.type') == 'stripe' && _.isUndefined(model.get('recurring_processor.account_id'))){
      sections.donation_form = true;
      fields.recurring_processor = true;
    }
  }

  if(model.get('enable_tipping') == 1){
    if(parseInt(model.get('tip_percent'), 10) == 0){
      sections.donation_form = true;
      fields.tip_percent = true;
    }
  }

  if(model.get('donation_receipt') == ''){
    sections.donation_form = true;
    fields.donation_receipt = true;
  }

  // ---------------------------------------------------

  if(model.get('enable_projects') == 1){
  }

  // Check for if it's in setup
  var has_warnings = false;
  _.each(fields, function(value, key, list){
    if(value == true){
      has_warnings = true;
    }
  }, this);

  return {
    has_warnings : has_warnings,
    sections : sections,
    fields : fields
  }
};